var vms = vms || {};
vms.home = vms.home || {};

vms.home = {
	sync: function (pID) {
			if (confirm('Are you sure you want to initiate data transfer between the cloud and vessel?')) {
				$sync = $("#vslSync");
				//Old Way (pre-1.7)
				$sync.attr("onclick", "").unbind("click");
				//New Way (1.7+)
				$sync.prop("onclick", null).off("click");
				$sync.append('<i class="far fawe-sync fawe-spin"></i>');
				$(".box.sync .link").html('');
				$(".box.sync .txt").html('Establishing connection...');
				$sync.removeClass("sync").addClass("syncing");

				apex.server.process("sync_vsm", {
					x01: pID
				}, {
					dataType: "text",
					success: function(pData) {
						vms.home.syncCheck(pID);
						location.reload();
					}
				});
			}
	},
	sync2: function (pID) {
			if (confirm('Are you sure you want to initiate data transfer between the cloud and vessel?')) {
				$sync = $("#vslSync");
				//Old Way (pre-1.7)
				$sync.attr("onclick", "").unbind("click");
				//New Way (1.7+)
				$sync.prop("onclick", null).off("click");
				
				$('#vslSyncIcon').addClass('fawe-spin');
				$("#vslSync2").html('Establishing connection...');

				apex.server.process("sync_vsm", {
					x01: pID
				}, {
					dataType: "text",
					success: function(pData) {
						vms.home.syncCheck(pID);
						location.reload();
					}
				});
			}
	},
	syncCheck: function (pID) {
		apex.server.process("sync_check", {
			x01: pID
		}, {
			dataType: "text",
			success: function(pData) {
				if (pData == 'Y') {
					setTimeout(function() {
						vms.home.syncCheck(pID);
					}, 300000);
				} else location.reload();
			}
		});			
	}
}